<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex md3 lg2>
        <v-text-field v-model="query.s_phone" label="手机号" class="pr-2" v-on:keyup.enter="getList()"></v-text-field>
      </v-flex>
      <v-flex md3 lg2>
        <v-text-field v-model="query.s_name" label="店铺名称" class="pr-2" v-on:keyup.enter="getList()"></v-text-field>
      </v-flex>
      <v-flex md3 lg2>
        <v-text-field v-model="query.s_admin" label="店长姓名" class="pr-2" v-on:keyup.enter="getList()"></v-text-field>
      </v-flex>

      <v-flex md3 lg2>
        <v-select v-model="query.s_show"
          :items="[{ label: '全部状态', value: '' }, { label: '已通过', value: true }, { label: '未审核', value: false }]"
          label="审核状态" item-text="label" item-value="value" @change="getList()"></v-select>
      </v-flex>
      <v-flex md3 lg2>
        <div>
          <v-select v-model="query.pageSize" :items="pageSizes" item-text="label" @change="getList()" item-value="value"
            label="每页条数" class="pr-2 inline-block" required></v-select>
        </div>
      </v-flex>

      <v-flex xs-12 md-12 lg-12 sm-12>
        <v-btn color="gray" @click="resetSearch()">重置</v-btn>
        <v-btn color="dark" @click="getList()">
          <v-icon size="14">mdi-account-search</v-icon>&nbsp;搜索
        </v-btn>
      </v-flex>

    </v-layout>

    <v-divider></v-divider>

    <v-layout wrap justify-space-between>


    </v-layout>

    <v-layout row wrap>
      <v-flex xs-12 md-12 lg-12 sm-12>
        <el-table ref="multipleTable" :data="items" tooltip-effect="dark" style="width: 100%" border v-loading="tableLoad"
          @selection-change="handleSelectionChange">
          <el-table-column label="店铺ID" prop="_id"></el-table-column>
          <el-table-column label="店铺名称" prop="s_name"></el-table-column>
          <el-table-column label="店长姓名" prop="s_admin"></el-table-column>
          <el-table-column label="联系电话" prop="s_phone"></el-table-column>

          <el-table-column label="简介">
            <template slot-scope="scope">
              <div>{{ scope.row.s_detail }}</div>
            </template>
          </el-table-column>
          <el-table-column label="地址">
            <template slot-scope="scope">
              <div>{{ scope.row.s_address }}</div>
            </template>
          </el-table-column>

          <el-table-column label="总盈利额">
            <template slot-scope="scope">
              <div>￥{{ Number(scope.row.s_balance).toFixed(2) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="已提现额">
            <template slot-scope="scope">
              <div>￥{{ Number(scope.row.s_cash).toFixed(2) }}</div>
            </template>
          </el-table-column>

          <el-table-column label="可提现额">
            <template slot-scope="scope">
              <div>￥{{ Number(scope.row.s_balance - scope.row.s_cash).toFixed(2) }}</div>
            </template>
          </el-table-column>

          <el-table-column label="配送费">
            <template slot-scope="scope">
              <div>￥{{ Number(scope.row.profit.pei).toFixed(2) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="费率">
            <template slot-scope="scope">
              <div>{{ `平台:${(scope.row.profit.ptget * 100).toFixed(2)}%,
                              代理:${(scope.row.profit.dlget * 100).toFixed(2)}%,商家:${(scope.row.profit.shget * 100).toFixed(2)}%` }}</div>
            </template>
          </el-table-column>

          <el-table-column prop label="商户类别">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.s_type == 1">大餐厅商户</div>
                <div v-if="scope.row.s_type == 2">商业街商户</div>

              </div>
            </template>
          </el-table-column>

          <el-table-column prop label="营业状态">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.s_status == true">营业中</div>
                <div v-if="scope.row.s_status == false">在休息</div>

              </div>
            </template>
          </el-table-column>
          

          <el-table-column prop label="小票机状态">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.p_on == true">启用中</div>
                <div v-if="scope.row.p_on !== true">未启用</div>

              </div>
            </template>
          </el-table-column>

          <el-table-column prop label="审核状态">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.s_show == true">已通过</div>
                <div v-if="scope.row.s_show == false">未通过</div>

              </div>
            </template>
          </el-table-column>

          <el-table-column prop label="是否允许提现">
            <template slot-scope="scope">
              <div>
                <div>{{ scope.row.can_cash ? '正常' : '冻结' }}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="序号" prop="sort"></el-table-column>
          <el-table-column label="操作">

            <template slot-scope="scope">

              <v-btn small slot="activator" v-if="getuid !='7'" color="success" @click="editIt(scope.row)">
                编辑
              </v-btn>
              <v-btn small slot="activator" v-if="userRole == 'admin'" color="warning" @click="cashIt(scope.row)">
                提现
              </v-btn>
              <v-dialog v-model="dialog2" persistent max-width="600px">

                <v-card>
                  <v-card-title>
                    <span class="text-h5">商家提现</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>

                      <v-flex xs12 md6>
                        <v-text-field label="店铺名称" v-model="currentData.s_name" disabled></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field label="手机号" v-model="currentData.s_phone" disabled></v-text-field>
                      </v-flex>

                      <v-flex xs12 md6>
                        <v-text-field label="总盈利额" v-model="currentData.s_balance" disabled></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field label="已提现额" v-model="currentData.s_cash" disabled></v-text-field>
                      </v-flex>

                      <v-flex xs12 md6>
                        <v-text-field label="可提现额" :placeholder="Number(currentData.s_balance -
                          currentData.s_cash).toFixed(2)" disabled></v-text-field>
                      </v-flex>

                      <small style="color: red;">* 本次最大的提现金额为 ￥ {{ Number(currentData.s_balance -
                        currentData.s_cash).toFixed(2) }}</small>
                      <v-flex xs12 md6>
                        <v-text-field label="请输入本次提现金额" v-model="currentData.num"></v-text-field>
                      </v-flex>
                    </v-container>

                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog2 = false">
                      关闭
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="createCash">
                      提交
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

            </template>
          </el-table-column>
        </el-table>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-end mt-3>
      <el-pagination @current-change="handleCurrentChange" :current-page="query.currentPage" :page-size="query.pageSize"
        layout="total,  prev, pager, next, jumper" :total="total"></el-pagination>
    </v-layout>
    <detail v-model='dialog' :msg="tempData" @change="updateMsgChange" @changemsg="changeMsg" />
  </v-container>
</template>
<script>
import detail from './edit'

let _this;
export default {
  components: { detail },
  props: {
    load: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    load(val) {
      if (val) {
        this.pageLoad = val
      }
    },
    pageLoad(val) {
      if (val) {
        this.getList();
      }
    }
  },
  data() {
    return {
      pageLoad: false,
      dialog2: false,
      currentData: {},
      tempData: {},
      items: [],
      userRole: sessionStorage.getItem('role'),
      getuid:sessionStorage.getItem('uid'),
      dialog: false,
      query: {
        s_name: '',
        s_admin: '',
        s_phone: '',
        s_show: '',

        currentPage: 1,
        pageSize: 10
      },
      multipleSelection: [],
      pageSizes: this.$pageSizes,
      tableLoad: false,
      total: 0,
    };
  },
  mounted() {
    _this = this;
    this.getList();
  },
  methods: {
    updateMsgChange(val) {
      this.dialog = val
    },
    async createCash() {
      if (Number(this.currentData.num) > Number(this.currentData.s_balance - this.currentData.s_cash)) {
        this.$message({
          message: '提现金额填写错误！',
          type: 'danger'
        })
        return
      }
      if (Number(this.currentData.num) > 0) {
        this.currentData.state = 1
        const res = await this.$post('admin/createCash', this.currentData)
        this.$message({
          message: '操作成功！',
          type: 'success'
        })
        this.$router.push({ path: 'cash' })

      }
      this.currentData = {}
      this.dialog2 = false
    },
    editIt(e) {

      this.dialog = true
      this.tempData = e

    },
    async cashIt(e) {

      this.dialog2 = true

      this.currentData = e

    },

    //获取列表
    async getList() {
      this.tableLoad = true;
      const res = await this.$post('admin/getMerchantList', this.query)
      _this.tableLoad = false;
      if (res.errno === 0) {
        //   for (let i in res.data.data) {
        //     res.data.data[i]._createTime = this.$time(res.data.data[i]._createTime)
        //   }
        _this.items = res.data.data;
        _this.total = res.data.count;
      }

    },
    async confirmOrder(e) {

      this.$confirm(`订单号${e.orderNum},是否完成当前订单?`).then(async r => {
        if (r == 'confirm') {

        }
      })

    },
    //重置搜索
    resetSearch() {
      this.query.s_name = ''
      this.query.s_admin = ''
      this.query.s_phone = ''
      this.query.s_show = ''
      this.getList();
    },

    //选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    //获取id
    getIds() {
      let arr = [];
      for (let i in this.multipleSelection) {
        arr.push(this.multipleSelection[i].id)
      }
      return arr
    },

    //跳转页码
    handleCurrentChange(val) {
      this.query.currentPage = val;
      this.getList();
    },


    //更新值
    changeMsg(e) {
      this.getList()
    }

  }
};
</script>
    